import { Button, Col, Row, TabPane } from 'reactstrap';
import { RiArrowDropRightLine } from 'react-icons/ri';
import { useEffect, useState } from 'react';
import { IoCamera } from 'react-icons/io5';
// import FaceId from '../../../../assets/images/icons/face-id.svg';

interface PermissionDeviceProps {
  handleChangeTabe: (tab: string) => void;
}

const PermissionDevice: React.FC<PermissionDeviceProps> = ({
  handleChangeTabe,
}) => {
  const [hasAccess, setHasAccess] = useState(false);
  const [youNegative, setYouNegative] = useState(false);

  const handlePermissionDevices = () => {
    if (navigator.mediaDevices) {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream) => {
          if (stream.getVideoTracks().length > 0) {
            setHasAccess(true);
            setYouNegative(false);
          }
        })
        .catch((error) => {
          setHasAccess(false);
          setYouNegative(true);
        });
    }
  };

  return (
    <TabPane tabId="1">
      <Row>
        <Col sm="12" className="d-flex justify-content-center">
          <IoCamera
            className="alert"
            size={150}
            style={{ color: !hasAccess ? '#82868b' : '#28c76f' }}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col
          sm="12"
          className="d-flex justify-content-center flex-column align-items-center"
        >
          {!hasAccess ? (
            <>
              <h3 className="text-primary">Acesso à câmera</h3>
              <p>É necessário permitir acesso à sua câmera.</p>
            </>
          ) : (
            <>
              <h3 className="text-primary">Acesso à câmera concedido</h3>
              <p>Câmera já esta habilitada, clique em próximo</p>
            </>
          )}

          {youNegative ? (
            <p className="text-danger">
              Será necessário acessar as permissões do navegador para liberar
            </p>
          ) : null}

          <Button
            color="warning"
            onClick={handlePermissionDevices}
            disabled={hasAccess}
            style={{ cursor: !hasAccess ? 'pointer' : 'not-allowed' }}
          >
            Habilitar Câmera
          </Button>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-between">
          <div />
          <Button
            size="sm"
            onClick={() => handleChangeTabe('2')}
            color={hasAccess ? 'primary' : 'secondary'}
            style={{ cursor: hasAccess ? 'pointer' : 'not-allowed' }}
            disabled={!hasAccess}
          >
            Próximo <RiArrowDropRightLine size={25} />
          </Button>
        </Col>
      </Row>
    </TabPane>
  );
};

export default PermissionDevice;
